import { buildStaffMenu } from "./staffMenu"
// Also available for Talent Development-specific tweaks: overrideByKey, removeByKey, addItems from "./helpers"

/**
 * Talent Development role menu — cloned from the shared staff base.
 *
 * Currently mirrors the staff base exactly. To add Talent Development-specific overrides
 * without affecting other roles, edit only this file. Example:
 *
 *   const menu = buildStaffMenu()
 *   return removeByKey(menu, "leave-request")
 */
export const buildTalentDevelopmentMenu = () => buildStaffMenu()
